<mat-sidenav-container
  class="side-nav-layout-container pencil-thin-scrollbar"
  [hasBackdrop]="false"
>
  <mat-sidenav-content>
    <div class="main-content-wrapper">
      <div class="main-header">
        <ng-content select="[main-header]"></ng-content>
      </div>
      <div class="main-body">
        <ng-content select="[main-content]"></ng-content>
      </div>
    </div>
  </mat-sidenav-content>

  <mat-sidenav #sidenav mode="over" position="end" class="app-side-nav-layout-sidenav">
    <div class="header">
      <div class="header-lhs">
        <app-pencil-button
          theme="icon"
          icon="close"
          [iconConfig]="{ type: IconTypes.materialIcon, outlined: false }"
          (clickEvent)="close()"
          class="header-button"
        ></app-pencil-button>
        <span class="sidenav-title">{{ sidenavTitle }}</span>
      </div>
      <div class="header-rhs">
        <app-pencil-button
          *ngIf="menu"
          theme="icon"
          icon="more_horiz"
          [iconConfig]="{ type: IconTypes.materialIcon }"
          class="header-button"
          [matMenuTriggerFor]="menu"
        ></app-pencil-button>
      </div>
    </div>
    <div class="content-body">
      <ng-content select="[sidenav-body]"></ng-content>
    </div>
    <div class="footer" *ngIf="showFooter">
      <app-pencil-button
        *ngIf="showSecondaryButton"
        theme="secondary"
        [icon]="secondaryBtnIcon"
        [iconConfig]="{ type: IconTypes.materialIcon }"
        [label]="secondaryBtnLabel || ('Cancel' | translate)"
        (clickEvent)="onSecondaryBtnClick()"
      ></app-pencil-button>
      <app-pencil-button
        theme="primary"
        [icon]="primaryBtnIcon"
        [iconConfig]="{ type: IconTypes.materialIcon }"
        [label]="primaryBtnLabel || ('Done' | translate)"
        [disabled]="
          (formState$ | async) === FormState.SubmittedAndInvalid ||
          (formState$ | async) === FormState.Loading
        "
        [showSpinner]="(formState$ | async) === FormState.Loading"
        (clickEvent)="onPrimaryBtnClick()"
      ></app-pencil-button>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
